import React from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { CardSummary } from 'app/KinerjaPSPegawaiPage/components/CardSummary'
import { CardSummaryPraktikKinerja } from 'app/KinerjaPSPegawaiPage/components/CardSummaryPraktikKinerja'
import { DialogConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogConfirmation'

import type { TPerencanaan } from 'types/kinerja-ps-pegawai'

type TDialogChangePraktikKinerjaProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
const DialogChangePraktikKinerja: React.FC<
  TDialogChangePraktikKinerjaProps
> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <DialogConfirmation
      isOpen={isOpen}
      autoFocus={false}
      returnFocus={false}
      size="sm"
      title="Ubah Praktik Kinerja?"
      description="Setelah diubah, pastikan Anda lanjut mengajukan Perencanaan."
      ctaConfirm="Ke Praktik Kinerja"
      onClickConfirm={onConfirm}
      onClickCancel={onClose}
    />
  )
}

type TSectionPraktikKinerjaProps = {
  data: TPerencanaan
  showRightAction?: boolean
}
export const SectionPraktikKinerja: React.FC<TSectionPraktikKinerjaProps> = ({
  data,
  showRightAction = false,
}) => {
  const router = useRouter()
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)

  return (
    <>
      <CardSummary
        title="Praktik Kinerja"
        {...(showRightAction && {
          onChangeClicked: () => setIsDialogOpen(true),
        })}
      >
        <div className="grid grid-cols-2 p-6 bg-white gap-x-4 rounded-b-md">
          <CardSummaryPraktikKinerja title="Anda memilih Praktik Kinerja:">
            <div className="px-6 py-4 space-y-6">
              <div className="space-y-1">
                <Text variant="heading-sm">
                  {data?.praktikKinerjaRhkPs?.nama}
                </Text>
                <Text>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: (
                        data?.praktikKinerjaRhkPs?.keterangan ?? ''
                      ).replace(/\\n/g, '<br />'),
                    }}
                  />
                </Text>
              </div>
            </div>
          </CardSummaryPraktikKinerja>

          <CardSummaryPraktikKinerja title="Untuk difokuskan di satuan pendidikan:">
            <div className="px-6 py-4 space-y-6">
              <div>
                <ol className="pl-6 list-disc">
                  {(data?.praktikKinerjaSatuanPendidikan ?? []).map(
                    ({ satuanPendidikan }, index) => (
                      <li key={index}>{satuanPendidikan}</li>
                    )
                  )}
                </ol>
              </div>
            </div>
          </CardSummaryPraktikKinerja>
        </div>
      </CardSummary>

      <DialogChangePraktikKinerja
        isOpen={isDialogOpen}
        onConfirm={() => {
          router.push(
            `${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/praktik-kinerja`
          )
          setIsDialogOpen(false)
        }}
        onClose={() => {
          setIsDialogOpen(false)
        }}
      />
    </>
  )
}
